/** @jsxImportSource @emotion/react */

import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import _isEqual from "lodash/isEqual";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectUsername } from "store/auth";
import { initialState, selectDataMemberVip } from "store/memberVip";
import { getMemberVip } from "store/memberVip/member.thunk";
import { Swiper, SwiperSlide } from "swiper/react";

import VipDetailsItemM from "../VipDetailsItem";
import { SwiperVipDetailsMStyle } from "./style.index";

const SwiperVipDetailsM = () => {
  const dispatch = useAppDispatch();
  const username = useSelector(selectUsername);
  const { data: dataMemberVip } = useAppSelector(selectDataMemberVip);

  const isDataEmptyMemberVip = _isEqual(
    initialState.dataMemberVip.data,
    dataMemberVip,
  );

  useEffect(() => {
    if (!username) return;
    if (!isDataEmptyMemberVip) return;
    dispatch(getMemberVip({ username }));
  }, [username]);

  return (
    <>
      <Swiper
        centeredSlides={true}
        css={SwiperVipDetailsMStyle.wrapper}
        slidesPerView={1.5}
        spaceBetween={15}
        loop
      >
        {dataMemberVip.board?.map((item, index) => (
          <SwiperSlide key={index}>
            <VipDetailsItemM {...item} />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default SwiperVipDetailsM;
